// Third party libraries
import { Image } from 'semantic-ui-react';

// Models
import { GeneralOffer, PeriodicityEnum, Plan } from '../../../../../../../models/payment';

// Locales
import I18n from '../../../../../../../i18n';

// Styles
import './index.scss';

// Interfaces
interface ParamsInterface {
    maxStudents?: number;
    onSelect: () => void;
    periodicity: PeriodicityEnum | null;
    plan: Plan;
    offer?: GeneralOffer;
    selected: boolean;
};

const HorizontalPlanCard = ({ maxStudents, onSelect = () => {}, periodicity, plan: data, offer, selected }: ParamsInterface) => {

    const onClick = () => (!maxStudents || maxStudents < data.maxStudents) && onSelect();

    const planPrice = periodicity === PeriodicityEnum.Monthly ? data.monthlyPrice : data.annualPrice;

    const discountPrice = offer ? planPrice * ( offer.discount / 100 ): 0;

    let newPlanPrice = planPrice - discountPrice;

    newPlanPrice = parseFloat(newPlanPrice.toFixed(2));

    return <div className={ `horizontalPlanCard ${ selected ? 'selected' : '' } ${ !offer || offer?.discount === 0 ? 'hideRibbon' : '' } ${ !!maxStudents && maxStudents >= data.maxStudents ? 'disabled' : '' }` } data-ribbon={ '-' + offer?.discount + '%' } onClick={ onClick }>
        <Image src={ data.logo } />
        <div className='content'>
            <span className='planTitle'>{ data.name }</span>
            <span className='manageText'>{ I18n.t('landing.manageUpToStudents', { maxStudents: data.maxStudents }) }</span>
            { newPlanPrice !== planPrice && <span className='oldPrice'>{ '$' + planPrice }</span> }
            <div className='priceBox'>
                <span className='newPrice'>{ '$' + (newPlanPrice || planPrice) }</span>
                <span className='periodicity'>{ periodicity === PeriodicityEnum.Monthly ? `/${I18n.t('setup.month')}` : `/${I18n.t('setup.year')}` }</span>&nbsp;&nbsp;&nbsp;
                {
                    offer && <span className='forEver'>{ I18n.t(periodicity === PeriodicityEnum.Annual ? 'landing.uniqPayment' : offer?.discount !== 0 ? 'landing.forEver' : '') }</span>
                }
            </div>
        </div>
    </div>;

}

export default HorizontalPlanCard;